import { useEffect, useState } from 'react'

import { Text } from '@wartek-id/text-v1'

import styles from './TooltipRelative.module.css'

export default function TooltipRelative() {
  const [displayText, setDisplayText] = useState('Le')
  const CONSTANT_TEXT = 'Level Anda adalah... Isi dulu refleksinya~'
  const CONSTANT_INTERVAL = 100
  const CONSTANT_DELAY = 3000

  useEffect(() => {
    let i = 2
    let typingInterval
    let resetTimeout
    const callbackInterval = () => {
      if (i < CONSTANT_TEXT.length) {
        setDisplayText((prevText) => prevText + CONSTANT_TEXT.charAt(i))
        i++
      } else {
        resetTimeout = setTimeout(() => {
          i = 2
          setDisplayText('Le')
          typingInterval = setInterval(callbackInterval, CONSTANT_INTERVAL)
        }, CONSTANT_DELAY + CONSTANT_INTERVAL)
        clearInterval(typingInterval)
      }
    }
    typingInterval = setInterval(callbackInterval, CONSTANT_INTERVAL)
    return () => {
      clearInterval(typingInterval)
      clearTimeout(resetTimeout)
    }
  }, [])

  return (
    <div className="flex flex-col">
      <div className={styles.tooltipArrow} />
      <div className={styles.tooltipContent}>
        <Text className="text-left">{displayText}</Text>
      </div>
    </div>
  )
}
